import {Alert, alpha, Box, Grid, IconButton, Paper, Stack, Typography, useTheme} from "@mui/material";
import {Link} from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import I18n from "i18n-js";
import {Button, Field, FieldsContainer, Form, FormToolbar, Spacer, TextField} from "../../../../../common";
import React, {useEffect} from "react";
import {styled} from "@mui/system";
// @ts-ignore
import {ReactComponent as ReactLogo} from "assets/logo.svg";
import usePasswordRecoveryRequestForm from "./usePasswordRecoveryRequestForm";
import {PasswordRecoveryRequestForm} from "./passwordRecoveryRequestAPI";
import CheckIcon from "@mui/icons-material/Check";

const Logo = styled(ReactLogo)`
    max-height: 70px;
    min-height: 70px;
`;

interface PasswordRecoveryRequestFormProps {
  onRequestSent: Function;
}

export default function RecoveryRequestForm({onRequestSent}: PasswordRecoveryRequestFormProps) {
  const theme = useTheme();
  const {
    item,
    errors,
    loading,
    process,
    onChange,
  } = usePasswordRecoveryRequestForm({defaultValues: {} as PasswordRecoveryRequestForm, onRequestSent});

  return (
    <Box
      flex={1}
      flexDirection="column"
      display="flex"
      alignItems="center"
      //justifyContent="center"
      padding={4}
    >
      <Grid container justifyContent="center">
        <Grid
          item
          xs={12}
          sx={{
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Paper
            sx={{
              padding: 4,
              maxWidth: "sm",
              backgroundColor: theme =>
                alpha(theme.palette.background.paper, 0.95),
            }}
            elevation={5}
          >
            <Link to={"/login"}>
              <IconButton>
                <ChevronLeftIcon/>
              </IconButton>
            </Link>
            <Stack spacing={2} sx={{alignItems: "center"}}>
              <Link
                to="/"
                style={{
                  color: theme.palette.mode === "dark" ? "white" : "#001e3c",
                }}
              >
                <Logo/>
              </Link>
              <Typography variant="h2">{I18n.t("App.title")}</Typography>
              <Typography variant="h5">{I18n.t("PasswordRecoveryRequest.title")}</Typography>
              <Typography variant="body1">{I18n.t("PasswordRecoveryRequest.description")}</Typography>
            </Stack>
            <Spacer h={4}/>
            <Form
              item={item}
              errors={errors}
              onChange={onChange}
              translationCategory="PasswordRecoveryRequest.attributes"
            >
              {
                errors.email && errors.email === 'E-mail address not found.'
                ? (
                  <>
                    <Alert severity="error">
                      <Typography variant="body1" sx={{fontWeight: "bold"}}>
                        {I18n.t("PasswordRecoveryRequest.resetFailed")}
                      </Typography>
                      <Typography variant="body1">

                        {I18n.t("PasswordRecoveryRequest.resetFailedDescription")} <br />
                        {I18n.t("PasswordRecoveryRequest.resetFailedDescription2")}
                      </Typography>
                    </Alert>
                    <Spacer h={2}/>
                  </>
                )
                : ''
              }
              {
                errors.email && errors.email === 'You’ve recently requested a code. Please try again shortly.'
                  ? (
                    <>
                      <Alert severity="error">
                        <Typography variant="body1" sx={{fontWeight: "bold"}}>
                          {I18n.t("PasswordRecoveryRequest.rateLimitError")}
                        </Typography>
                        <Typography variant="body1">

                          {I18n.t("PasswordRecoveryRequest.rateLimitErrorDescription")} <br />
                          {I18n.t("PasswordRecoveryRequest.rateLimitErrorDescription2")}
                        </Typography>
                      </Alert>
                      <Spacer h={2}/>
                    </>
                  )
                  : ''
              }
              <FieldsContainer>
                <Field xs={12}>
                  <TextField
                    id={"email"}
                    onEnter={process}
                    error={""}
                  />
                </Field>
              </FieldsContainer>
            </Form>
            <Spacer h={2}/>
            <FormToolbar variant="dense">
              <Spacer right/>
              <Button
                variant="contained"
                loading={loading}
                fullWidth
                onClick={() => process()}
              >
                {I18n.t("PasswordRecoveryRequest.reset")}
              </Button>
            </FormToolbar>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}